<template>
  <div class="user-info" :class="{ 'collapsed': isCollapsed }">
    <div class="user-avatar">
      <span>{{ userInitials }}</span>
    </div>
    <div class="user-details" v-show="!isCollapsed">
      <p class="user-name">Admin User</p>
      <p class="user-role">Administrator</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    userInitials: {
      type: String,
      default: 'U'
    }
  }
}
</script>

<style scoped>
.user-info {
  display: flex;
  align-items: center;
  padding: 1rem 1.25rem;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  margin-bottom: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.04);
  transition: all 0.3s ease;
}

.user-info.collapsed {
  justify-content: center;
  padding: 1rem 0.5rem;
}

.user-info:hover {
  background: rgba(255, 255, 255, 0.05);
}

.user-avatar {
  width: 42px;
  height: 42px;
  background: #4f46e5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  font-weight: 600;
  color: white;
  font-size: 1rem;
  flex-shrink: 0;
}

.user-info.collapsed .user-avatar {
  margin-right: 0;
}

.user-details {
  flex: 1;
}

.user-name {
  font-weight: 600;
  margin: 0;
  font-size: 0.95rem;
  color: white;
}

.user-role {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
  margin: 0.2rem 0 0;
}

:root[data-theme="light"] .user-info {
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

:root[data-theme="light"] .user-name {
  color: #1f2937;
}

:root[data-theme="light"] .user-role {
  color: rgba(0, 0, 0, 0.6);
}

@media (max-width: 480px) {
  .user-info {
    padding: 1rem;
  }
  
  .user-avatar {
    width: 38px;
    height: 38px;
    font-size: 0.9rem;
  }
}
</style> 